export enum LinkTypes {
  ADMIN = 'admin',
  BASE = 'base',
  TEACHER = 'teacher',
}
